import React, { useState } from "react";
import { Table, Button, Space } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import { ZoomInOutlined } from "@ant-design/icons";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function UserTable() {
  const general = useGeneralStore();
  const reports = useReportsStore()
  const { auth } = usePersistedStore();
  const data = reports.purchases.data;
  const loading = reports.purchases.loading;
  const userInfoResources = auth.userInfo.Resources;

  const [requestId, setRequestId] = useState();

  const columns = [
    {
      title: "جزئیات بیمه نامه",
      dataIndex: "operation",
      key: "operation",
      width: 85,
      render: (_, record) =>
        data.length >= 1 && (
          <Space size="middle">
            <Button type='link' onClick={() => {
              reports.getInsuranceDetailsInfo(record.InsInsuranceRequestID)
              setRequestId(record.InsInsuranceRequestID);
              general.ToggleInsuranceDetailsModal();
            }
            }><ZoomInOutlined /></Button>
          </Space>
        ),
    },
    {
      title: "نام بیمه گزار",
      dataIndex: "PubClientAccountName",
      width: 200,
      key: "PubClientAccountName",
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "رشته",
      dataIndex: "InsuranceTypeName",
      width: 170,
      key: "InsuranceTypeName",
    },
    {
      title: "مبلغ پرداختی",
      dataIndex: "Payment",
      width: 170,
      key: "Payment",
      render: data => strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ کل",
      dataIndex: "SummarizeAmount",
      width: 170,
      key: "SummarizeAmount",
      render: data => strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مدت بیمه نامه",
      dataIndex: "InsurancePeriodTypeName",
      width: 170,
      key: "InsurancePeriodTypeName",
    },
    {
      title: "شرکت بیمه",
      dataIndex: "CompanyName",
      width: 170,
      key: "CompanyName"
    },
    {
      title: "وضعیت",
      dataIndex: "InsuranceRequestStatusTitle",
      width: 170,
      key: "InsuranceRequestStatusTitle"
    },
    {
      title: "تخفیف",
      dataIndex: "VoucherAmount",
      width: 170,
      key: "VoucherAmount",
      render: data => strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "جریمه",
      dataIndex: "ThirdPartyPenaltyPrice",
      width: 170,
      key: "ThirdPartyPenaltyPrice",
      render: data => strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "روش پرداخت",
      dataIndex: "Installment",
      width: 170,
      key: "Installment",
      render: data => data ? 'اقساطی' : 'نقدی'
    },
    {
      title: "کد رهگیری",
      dataIndex: "TrackingCode",
      width: 170,
      key: "TrackingCode",
      render: text => text && text.toUpperCase().replace('BM-', '')
    },
    {
      title: "تاریخ صدور",
      dataIndex: "IssuanceDate",
      width: 170,
      key: "IssuanceDate",
      render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')),
    }
  ];

  return (
    <>
      <Table
        style={{ overflowX: 'scroll' }}
        size="small"
        className="custom-table"
        bordered
        loading={loading}
        rowKey="TrackingCode"
        scroll={true}
        dataSource={data}
        columns={userInfoResources &&
          (userInfoResources.includes("BusinessSaleReport") ||
            userInfoResources.includes("BusinessSupportReport")) ?
          columns : (columns.filter(col => col.dataIndex !== 'operation'))}
      />
      <InsuranceDetails requestId={requestId} />
    </>
  );
}